import { createPortal } from 'react-dom'
import React, { useRef, useEffect, forwardRef } from 'react'

export const Modal = forwardRef((props, modalRef) => {
  const {
    isOpen = true,
    closeable = true,
    children,
    className = '',
    ...rest
  } = props
  const dialogRef = modalRef || useRef(null)

  useEffect(() => {
    const dialogElement = dialogRef.current

    if (isOpen) {
      dialogElement.showModal()
    } else {
      dialogElement.close()
    }
  }, [isOpen])

  const closeDialog = event => {
    event.preventDefault()
    dialogRef.current.close()
  }

  const enhancedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && typeof child.type !== 'string') {
      return React.cloneElement(child, { closeDialog, closeable, ...rest })
    }
    return child
  })

  return createPortal(
    <dialog ref={dialogRef} className={className}>
      {isOpen && enhancedChildren}
    </dialog>,
    document.body
  )
})
